import I18n from 'I18n';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import styled from 'foundations-theming/utils';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { memo } from 'react';
import { USD } from 'self-service-api/constants/CurrencyCodes';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "Case__Bold",
  componentId: "sc-14sjkuj-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-50']);
});
const Case = ({
  caseStudyKey,
  href,
  logo,
  price,
  externalLink = true
}) => {
  const handleLinkClick = () => {
    trackClickedLink({
      name: 'case-study-link',
      value: getI18nText('case-studies.learnMore', {
        locale: 'en-us'
      }),
      type: 'external',
      url: href
    });
  };
  const companyInfoKeys = Object.keys(I18n.text(`case-studies.cases.${caseStudyKey}.companyInfo`));
  const metrics = I18n.text(`case-studies.cases.${caseStudyKey}.metrics`, {
    defaultValue: ''
  });
  const metricsKeys = Object.keys(typeof metrics === 'string' || !metrics ? {} : metrics);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    children: [/*#__PURE__*/_jsx(CardSection, {
      paddingBlockEnd: "800",
      children: /*#__PURE__*/_jsx(Image, {
        alt: caseStudyKey,
        src: logo,
        responsive: false,
        blockSize: "40px"
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h3",
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `case-studies.cases.${caseStudyKey}.headline`
        })
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `case-studies.cases.${caseStudyKey}.description_jsx`,
          elements: {
            Price: () => {
              return price ? /*#__PURE__*/_jsx(PriceDisplay, {
                price: price,
                currencyCode: USD
              }) : '';
            }
          }
        }), "\xA0", /*#__PURE__*/_jsxs(Link, {
          external: externalLink,
          href: href,
          onClick: handleLinkClick,
          "aria-atomic": true,
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "case-studies.learnMore"
          }), /*#__PURE__*/_jsx(ScreenReaderOnly, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `case-studies.cases.${caseStudyKey}.headline`
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      marginBlockStart: "auto",
      children: /*#__PURE__*/_jsxs(CardGrid, {
        columns: 2,
        gutterSize: 12,
        children: [/*#__PURE__*/_jsx("div", {
          children: companyInfoKeys.map(key => /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              as: "span",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `case-studies.companyInfo.labels.${key}`
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: `case-studies.cases.${caseStudyKey}.companyInfo.${key}`
            })]
          }, key))
        }), /*#__PURE__*/_jsx("div", {
          children: metricsKeys.map(key => /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: `case-studies.cases.${caseStudyKey}.metrics.${key}`,
              elements: {
                Price: () => {
                  return price ? /*#__PURE__*/_jsx(PriceDisplay, {
                    price: price,
                    currencyCode: USD
                  }) : '';
                },
                Bold,
                FormattedIntlCurrency,
                // TODO - remove after translations
                FormattedPercentage
              }
            })
          }, key))
        })]
      })
    })]
  });
};
export default /*#__PURE__*/memo(Case);